import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE = createAsyncActionType(
  "GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE"
);



// WEBPACK FOOTER //
// ./src/features/score-card/types/getAllScoreCardRiskFactorsByType.js